import {Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {Observable} from 'rxjs';
import {FormGroup} from "@angular/forms";

import {environment} from '../../environments/environment';

declare var adyen: any;

@Injectable()
export class AdyenService {
  private renderer: Renderer2;
  private scriptUploaded: boolean;
  private formElement: HTMLElement;
  private formData: FormGroup;


  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  initAdyen() {
    const promise = new Promise(resolve => {
      if (document.getElementById('adyen_cse') == null) {
        let done = false;
        const s = this.renderer.createElement('script');
        s.onload = function () {
          if (!done) {
            done = true;
            resolve('ok');
          }
        };
        s.onreadystatechange = function () {
          let state;
          if (!done) {
            state = s.readyState;
            if (state === 'complete') {
              done = true;
              resolve('ok');
            }
          }
        };
        s.handleError = function () {
          if (!done) {
            done = true;
            resolve('error');
          }
        };
        s.id = 'adyen_cse';
        s.type = `text/javascript`;
        s.src = environment.Payment.url;
        this.renderer.appendChild(document.body, s);
      } else {
        resolve('ok');
      }
    });
    return Observable.fromPromise(promise);
  }

  handleSubscribe = (formElement, formData) => (data) => {
    this.scriptUploaded = data === 'ok';
    this.formElement = formElement.nativeElement;
    this.formData = formData;
  }

  getEncryptedData(formData: any) {
    const options = {enableValidations: false};
    const encryptedForm = adyen.createEncryptedForm(this.formElement, options);
    const cseInstance = adyen.encrypt.createEncryption(encryptedForm.key, options);
    const cardData = {
      number: formData.payment_card,
      cvc: formData.payment_cvc,
      holderName: formData.payment_card_holder_name,
      expiryMonth: formData.expiry_month,
      expiryYear: formData.expiry_year,
      generationtime: new Date().toISOString()
    };

    return cseInstance.encrypt(cardData);
  }

  get creditCardType() {
    const cardNumber = this.formData.get('payment_card').value.replace( /\D/g, '' );
    if (!cardNumber) {
      return null;
    }
    let card = adyen.cardTypes.determine(cardNumber);
    if (!card) {
      return null;
    }
    return card.cardtype;

  }
}



// WEBPACK FOOTER //
// ./src/app/services/adyen.service.ts